import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import IconButton from "@material-ui/core/IconButton";

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Badge,
} from "reactstrap";

import Breadcrumb from "../../../layout/breadcrumb";
import { useHistory, useLocation } from "react-router-dom";

import SweetAlert from "sweetalert2";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Switch from "react-switch";
import { fetchAssurance } from "../../../redux/assurance/assuranceActions";
import BudgeComponent from "../../../components/BudgeComponent";

const AssuranceList = ({ location }) => {
  const role = localStorage.getItem("role");
  const history = useHistory();
  const [checked, setChecked] = useState(false);
  const dispatch = useDispatch();
  const listAssurance = useSelector(
    ({ assuranceReducers }) => assuranceReducers.assurances
  );
  const profil = localStorage.getItem("profil");
  useEffect(() => {
    dispatch(fetchAssurance());
  }, []);

  const handleChange = () => {
    setChecked(true);
  };

  const columns = [
    {
      name: "Assurance",
      selector: "socialReason",
      sortable: true,
    },
    {
      name: "Matricule Fiscale",
      selector: "taxIndetification",
      sortable: true,
    },
    { name: "Téléphone", selector: "phone", sortable: true },
    {
      name: "Actif",
      cell: (row) => <BudgeComponent status={row.isActive} />,
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          {profil === "User" ? (
            <IconButton
            color="primary"
            onClick={() => {
              history.push({
                pathname: "/gest_intervenant/assurance/update_assurance",
                state: { row },
              });
            }}
          >
            <i className="icofont icofont-eye-alt"></i>
          </IconButton>
          ) : (
            <>
              <IconButton
                color="primary"
                onClick={() => {
                  history.push({
                    pathname: "/gest_intervenant/assurance/update_assurance",
                    state: { row, update: true },
                  });
                }}
              >
                <i className="icofont icofont-ui-edit"></i>
              </IconButton>
              <IconButton
                color="primary"
                onClick={() => {
                  history.push({
                    pathname: "/gest_intervenant/assurance/update_assurance",
                    state: { row },
                  });
                }}
              >
                <i className="icofont icofont-eye-alt"></i>
              </IconButton>
            </>
          )}
        </div>
      ),

      button: true,
    },
  ];
  const columnsC = [
    {
      name: "Assurance",
      selector: "socialReason",
      sortable: true,
    },
    {
      name: "Matricule Fiscale",
      selector: "taxIndetification",
      sortable: true,
    },
    { name: "Tel", selector: "phone", sortable: true },
  ];
  return (
    <div>
      <Breadcrumb parent={"Assurance"} title={"Liste des Assurances"} />
      <Container fluid={true}>
        <Card className="shadow-lg p-0 shadow-showcase">
          <CardHeader
            className="ml-2"
            style={{ cursor: "pointer", padding: "10px" }}
            onClick={() => {}}
          >
            <span className="float-left">
              <h6 className="mt-1">{"Filtrer"}</h6>
            </span>

            <span className="float-right ">
              <h4>
                {" "}
                <i className="fa fa-angle-down"></i> :{" "}
                <i className="fa fa-angle-up"></i>
              </h4>
            </span>
          </CardHeader>

          <CardBody className="pt-0" hidden="">
            <Form className="theme-form">
              <Row>
                <Col md="12 mb-2">
                  <FormGroup>
                    <Label className="col-form-label "></Label>
                    <Input
                      className="form-control"
                      type="text"
                      onChange=""
                      value=""
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Form>
            <Button
              className="btn-pill btn-air-success"
              color="success"
              onClick=""
            >
              Recherche
            </Button>
          </CardBody>
        </Card>

        <Card className="shadow-lg p-0 shadow-showcase">
          <CardHeader className="m-0  align-button ">
            <Row>
              {role === "Courtier " ? (
                <></>
              ) : (
                <Col className="text-right">
                  <span>
                    {profil === "User" ? (
                      <></>
                    ) : (
                      <Button
                        className="btn-pill btn-air-primary "
                        color="primary"
                        onClick={() => {
                          history.push(
                            "/gest_intervenant/assurance/new_assurance"
                          );
                        }}
                      >
                        + {"Nouvelle Assurance"}
                      </Button>
                    )}
                  </span>
                </Col>
              )}
            </Row>
          </CardHeader>

          <CardBody className="pt-2">
            <DataTable
              noHeader
              pagination
              paginationComponentOptions={{
                rowsPerPageText: "Afficher",
                rangeSeparatorText: "/",
                selectAllRowsItem: true,
                selectAllRowsItemText: "all",
              }}
              columns={role === "Courtier " ? columnsC : columns}
              data={listAssurance}
              pointerOnHover={true}
              progressPending=""
              progressComponent={
                <div className="loader-box">
                  <div className="loader-1"></div>
                </div>
              }
            ></DataTable>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AssuranceList;
